"use client";

import { JSX, useContext } from "react";
import CustomButton from "rivals/components/shared/CustomButton";
import Link from "rivals/components/shared/Link";
import type { ImageBlock } from "rivals/shared/interfaces/Content";
import { setData } from "rivals/shared/utils/qa";
import styles from "./ImageBlock.module.scss";
import strings from "./strings";
import type { Props } from "./types";
import { LightBoxContext } from "../LightBox/context";

const DATA_PHILTER = "image-block";

function ImageBlock({
  alt,
  caption,
  credit,
  src,
  url,
  imageIndex
}: Props): JSX.Element {
  const {
    setVisible: setLightBoxVisible,
    setCurrent: setLightBoxCurrent
  } = useContext(LightBoxContext);

  function renderCaption(): JSX.Element | null {
    let captionText = caption;

    if (credit) {
      captionText = `${caption ? `${caption} ` : ""}${strings.by} ${credit})`;
    }

    return (
      <figcaption
        {...setData(DATA_PHILTER, "caption")}
        className={styles.caption}
      >
        {captionText}
      </figcaption>
    );
  }

  // Using a standard html img tag instead of next/image because the image
  // dimensions are not known prior to rendering
  const body = (
    <figure {...setData(DATA_PHILTER)} className={styles.figure}>
      <img alt={alt} className={styles.image} src={src} />
      {renderCaption()}
    </figure>
  );

  if (url) {
    return (
      <Link className={styles.container} href={url}>
        {body}
      </Link>
    );
  } else {
    return (
      <CustomButton
        ariaLabel="Open in lightbox"
        className={styles.customButton}
        onClick={() => {
          setLightBoxVisible(true);
          setLightBoxCurrent(imageIndex);
        }}
      >
        <div className={styles.container}>{body}</div>
      </CustomButton>
    );
  }
}

export default ImageBlock;
